var exports = {
  "R3": "TimestampRenderer.module__tooltipContainer___WkxGUV",
  "Mp": "TimestampRenderer.module__tooltipFullDateTime___WkxGUV",
  "fv": "TimestampRenderer.module__tooltipRelativeTime___WkxGUV",
};

module.exports = exports;
